import request from '@/utils/request'

export function loginid(idCard) {
    return request({
      url: '/cy/queryByIdCard.open',
      method: 'post',
      params: {
        idCard
      }
    })
  }

  export function loginNameIdcard(loginForm) {
    return request({
      url: '/user/szgk/login',
      method: 'post',
      data:loginForm
    })
  }